import { produce } from 'immer';

import {
  SIGNING_PROGRESS_INFORMATION__FETCH_REQUEST,
  SIGNING_PROGRESS_INFORMATION__FETCH_SUCCESS,
} from '@app/store/actionTypes';
import { SigningProgressInformationAction } from '@app/store/signingProgressInformation/actions';

interface Attachment {
  attachmentType: string;
  fileExtension: string | null;
  fileName: string | null;
}

interface SigningProgressInformationAttachment {
  attachments: Attachment[];
  participantId: string;
  participantContactInfo: string;
  participantName: string;
  participantSigningOrder: number;
}

export type SigningProgressInformationAttachmentsState = SigningProgressInformationAttachment[];

const initialState: SigningProgressInformationAttachmentsState = [];

export default function reducer(
  state: SigningProgressInformationAttachmentsState = initialState,
  action: SigningProgressInformationAction
) {
  switch (action.type) {
    case SIGNING_PROGRESS_INFORMATION__FETCH_REQUEST:
      return initialState;
    case SIGNING_PROGRESS_INFORMATION__FETCH_SUCCESS:
      return produce(state, (draft) => {
        const attachedAttachments = action.payload.attachments.filter((v) => v.file);

        const sortedParticipants = attachedAttachments
          .sort((a, b) => a.participant.signingOrder - b.participant.signingOrder)
          .map((v) => v.participant.participantId)
          .reduce((acc: string[], cur) => (acc.includes(cur) ? acc : [...acc, cur]), []);

        sortedParticipants.forEach((id) => {
          const participantAttachments = attachedAttachments.filter(
            (v) => v.participant.participantId === id
          );
          const attachments = participantAttachments.map((attachment) => ({
            attachmentType: attachment.request.attachmentType,
            fileExtension: attachment.file ? attachment.file.extension : null,
            fileName: attachment.file ? attachment.file.name : null,
          }));
          draft.push({
            participantId: participantAttachments[0].participant.participantId,
            participantSigningOrder: participantAttachments[0].participant.signingOrder,
            participantName: participantAttachments[0].participant.name,
            participantContactInfo: participantAttachments[0].participant.contactInfo,
            attachments,
          });
        });
      });
    default:
      return state;
  }
}
